// Hook para detectar si estamos en producción
import { useState, useEffect } from 'react';

export const useIsProduction = () => {
    const [isProduction, setIsProduction] = useState(false);

    useEffect(() => {
        // Verificamos si estamos en producción basándose en la URL
        const isProductionEnv = process.env.NODE_ENV === 'production';
        const isProductionURL = window.location.hostname === 'blog.anthonycazares.cafe';
        
        setIsProduction(isProductionEnv && isProductionURL);
    }, []);

    return isProduction;
};

// Componente wrapper para mostrar anuncios solo en producción
export const ProductionOnly = ({ children, fallback = null }) => {
    const isProduction = useIsProduction();
    
    return isProduction ? children : fallback;
};